import Logo from "./Logo";
import Navbar from "./Navbar";

const Sidebar = () => {
  return (
    <div className="space-y-5 w-full">
      <Logo />
      <Navbar />
    </div>
  );
};

export default Sidebar;
